import React, { Component } from "react";
import FlexView from "react-flexview";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import Api from "../../../../../Services/Api";
import { mapToObjectDDL } from "../../../../common/mapper";
import Container from "../../../../../modules/commons/Container";
import SimpleDDL from "../../../../../modules/SimpleDDL";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import { fetchDataAsync } from "../../../../../Services/Utils";
import SimpleLoadingOverlay from "../../../../../modules/popup/SimpleLoadingOverlay";
import { connect } from "react-redux";
import ErrorAction from "../../../../../Redux/ErrorRedux";
import LaporanPartHarian from "./components/laporanPartHarian";
import LaporanPartHarianByMekanik from "./components/laporanPartHarianByMekanik";
import LaporanMTDPart from "./components/laporanMTDPart";
import LaporanMTDPartByMekanik from "./components/laporanMTDPartByMekanik";
import LaporanYTDPart from "./components/laporanYTDPart";
import LaporanPartL3Y from "./components/laporanPartL3Y";

class DashboardLaporanHarianPartByMekanik extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      dataCabang: [],
      kodeCabang: null,
      selectedCabang: null,
      employeeId: null,
      search: {
        selectedCabang: null,
      },
    };
  }

  componentDidMount = async () => {
    this.fetchDataCabang();
    this.fetchLeaderId();
  };

  fetchLeaderId = async () => {
    const employeeId = localStorage.getItem("employeeId");
    const userId = localStorage.getItem("userId");
    if (employeeId) {
      this.setState((prevValue) => ({
        ...prevValue,
        employeeId: employeeId,
      }));
      return;
    }
    this.handleTriggerLoading();
    try {
      let res = await fetchDataAsync({
        asyncFn: () => Api.create("NAGAMAS_MASTER_DATA").findUserById(userId),
        menuName:
          "Dashboard Level Kepala Cabang Keatas - Laporan Harian By Team Leader",
        setError: this.props.setError,
      });
      if (res.ok) {
        localStorage.setItem("employeeId", res.data.data.id);
        this.setState((prevValue) => ({
          ...prevValue,
          employeeId: res.data.data.id,
        }));
      }
    } catch (error) {
      console.log("errors: ", error);
    }
    this.handleTriggerLoading();
  };

  fetchDataCabang = async () => {
    try {
      let res = await Api.create("NAGAMAS_MASTER_DATA").findAllMasterCabang();
      if (res.ok) {
        let filteredData = res.data.data.filter((item) =>
          this.props.menuAccess
            .map((data) => data.idRefObj)
            .includes(item.kodeCabang)
        );

        if (filteredData.length !== 0) {
          this.setState((prevValue) => ({
            ...prevValue,
            dataCabang: filteredData,
            kodeCabang: mapToObjectDDL(
              filteredData[0].namaDealer,
              filteredData[0].kodeCabang
            ),
            search: {
              selectedCabang: filteredData[0].kodeCabang,
            },
          }));
        }
      }
    } catch (error) {
      console.log("errors", error);
    }
  };

  handleSearchValueChange = (name, value) => {
    this.setState((prevValue) => ({
      ...prevValue,
      [name]: value,
    }));
  };

  // handleChangeCabang = (value) => {
  //     this.handleSearchValueChange("kodeCabang", value);
  //     this.setState((prevValue) => ({
  //       ...prevValue,
  //       sales: null,
  //       search: {
  //         ...prevValue.search,
  //         selectedSales: null,
  //       },
  //     }));
  // };

  handleChangeCabang = (value) => {
    this.setState((prevValue) => ({
      ...prevValue,
      kodeCabang: value,
      search: {
        ...prevValue.search,
        selectedCabang: value?.value || null,
      },
    }));
  };

  handleTriggerLoading = () => {
    this.setState((prevValue) => ({
      ...prevValue,
      loading: !prevValue.loading,
    }));
  };

  render() {
    return (
      <>
        <Container>
          <FlexView style={{ gap: "20px", alignItems: "center" }}>
            <SimpleDDL
              id="select_options_kode_cabang"
              box="search"
              name="kodeCabang"
              containerclassname="width width-250px"
              placeholder="Nama Cabang"
              menuPosition="fixed"
              options={this.state.dataCabang.map((item) =>
                mapToObjectDDL(item.namaDealer, item.kodeCabang)
              )}
              value={this.state.kodeCabang}
              onChange={(value) => this.handleChangeCabang(value)}
            />
          </FlexView>
          <Tabs>
            <TabList>
              <Tab>Laporan Part Harian</Tab>
              <Tab>Laporan Part Harian By Mekanik</Tab>
              <Tab>Laporan Jual Part MTD</Tab>
              <Tab>Laporan Jual Part MTD By Mekanik</Tab>
              <Tab>Laporan Jual Part YTD</Tab>
              <Tab>Laporan Jual Part 3 Tahun Terakhir</Tab>
            </TabList>
            <TabPanel>
              <LaporanPartHarian
                {...this.props}
                search={this.state.search}
                triggerLoading={this.handleTriggerLoading}
              />
            </TabPanel>
            <TabPanel>
              <LaporanPartHarianByMekanik
                {...this.props}
                search={this.state.search}
                employeeId={this.state.employeeId}
                triggerLoading={this.handleTriggerLoading}
              />
            </TabPanel>
            <TabPanel>
              <LaporanMTDPart
                {...this.props}
                search={this.state.search}
                employeeId={this.state.employeeId}
                triggerLoading={this.handleTriggerLoading}
              />
            </TabPanel>
            <TabPanel>
              <LaporanMTDPartByMekanik
                {...this.props}
                search={this.state.search}
                employeeId={this.state.employeeId}
                triggerLoading={this.handleTriggerLoading}
              />
            </TabPanel>
            <TabPanel>
              <LaporanYTDPart
                {...this.props}
                search={this.state.search}
                employeeId={this.state.employeeId}
                triggerLoading={this.handleTriggerLoading}
              />
            </TabPanel>
            <TabPanel>
              <LaporanPartL3Y
                {...this.props}
                search={this.state.search}
                employeeId={this.state.employeeId}
                triggerLoading={this.handleTriggerLoading}
              />
            </TabPanel>
          </Tabs>
          {this.state.loading && (
            <SimpleLoadingOverlay active={this.state.loading} />
          )}
        </Container>
      </>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setError: (payload) => dispatch(ErrorAction.setError(payload)),
  };
};

export default connect(
  null,
  mapDispatchToProps
)(DashboardLaporanHarianPartByMekanik);
